import React, { useState } from 'react'
import { IData } from './variables'
import ListingCard from '../ListingCard'
import classes from './listingGrid.module.scss'
import { FilterDropdown } from '../Forms/FormFields/FilterDropdown/FilterDropDown'
import { Grid } from '../Grid'
import Masonry from 'react-masonry-css'

export type IListingGridProps = {
  data: IData[]
  isSort?: boolean
}

export const Columns = {
  1300: 2,
  768: 2,
  767:1,
}

export default function ListingGrid(props: IListingGridProps) {
  const { data, isSort } = props
  const [filter, setFilter] = useState<string>('')

  const renderComponent = data.map((item, idx) => {
    return (
      <ListingCard key={idx} filter={filter} data={item}/>
    )
  })

  return classes.masonryGrid ? (
    <Grid container className={classes.listingGrid}>
      {isSort && (
        <Grid container>
          <FilterDropdown
            value=""
            onChange={(e: string) => (setFilter(e))}
            defaultSelectValue="Category"
            label={'category'}
            options={[{
              label: 'category',
              value: 'cat1',
            },{
              label: 'category2',
              value: 'cat2',
            },{
              label: 'category3',
              value: 'cat3',
            }]}
          />
        </Grid>
      )}
      <Masonry
        breakpointCols={Columns}
        className={classes.masonryGrid}
        columnClassName={classes.masonryColumn}
      >
        {
          renderComponent
        }
      </Masonry>
    </Grid>
  ) : null
}
